import { render, staticRenderFns } from "./OtherUserRegistrationGuidePdfModal.vue?vue&type=template&id=c08fd970&scoped=true&lang=pug"
import script from "./OtherUserRegistrationGuidePdfModal.vue?vue&type=script&lang=ts"
export * from "./OtherUserRegistrationGuidePdfModal.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserRegistrationGuidePdfModal.vue?vue&type=style&index=0&id=c08fd970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08fd970",
  null
  
)

export default component.exports